import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yuewei",
  "use": "icon-yuewei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yuewei\"><path d=\"M416 96v370.016L279.008 328.96 232.96 375.04 338.016 480H0v64h338.016L232.96 648.992 279.04 695.04 416 557.984V928h64V96h-64z m128 0v832h64V557.984l136.992 137.024 46.016-46.016L685.984 544H1024v-64H685.984l105.024-104.992-46.016-46.016L608 465.984V96h-64z\" p-id=\"22995\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol